
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import './index.css';
import { api } from '../../services/api';

import Menu   from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import SweetAlert from 'react-bootstrap-sweetalert';

function ParceriaCPF() {
  const [cpf,      setCPF]             = useState('');
  const [par_cadastro, setParCadastro] = useState('');
  const [par_nome, setParNome]         = useState('');
  const [nomerazao, setNomeRazao]      = useState('');
  const [par_status, setParStatus]     = useState('');
  const [pesquisa, setPesquisa]        = useState('');
  const [erro, setErro]                = useState('');
  const [sucesso, setSucesso]          = useState('');
  const [tipo, setTipo]                = useState('');
  
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '')

  function formatarCPF(e){
    var v=e.target.value.replace(/\D/g,"");    
    v=v.replace(/(\d{3})(\d)/,"$1.$2");    
    v=v.replace(/(\d{3})(\d)/,"$1.$2");    
    v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2");    
    e.target.value = v;    
    } 

  useEffect(() => {  
    setErro('');
    setSucesso('');      
    api.get('/parceria/1/associado', {
      params: {
        cpf
      }
    })
      .then(async response => {
        await
          Limpar();
          setCPF(response.data[0].par_cpf);
          setParCadastro(response.data[0].par_cadastro);
          setParNome(response.data[0].par_nome);
          setParStatus(response.data[0].par_cadastro);
          setNomeRazao(response.data[0].nomerazao);    
          setSucesso(response.data[0].par_nome); 
          setTipo(response.data[0].tipo); 
          if (response.data[0].nomerazao==null) {
            setSucesso(''); 
            setErro('Esse CPF está associado ao parceiro: '+response.data[0].par_nome+' mas não está na base do SUPERCLUBE! ');
            setNomeRazao("#### SEM CADASTRO NO SUPERCLUBE ###")
          }
      })
      .catch(err => {
        if (pesquisa!=''){
          setErro('Esse CPF não está associado a um parceiro FLORESTA SUPERMARKET!');
        }
        Limpar();
        return null;        
      });
      
  }, [pesquisa]);




function Limpar(x){
  setCPF('')
  setParCadastro('');
  setParNome('');
  setParStatus('');
  setNomeRazao('');    
}


  return <div>
    <Menu modulo=""/>
    <div className="container-fluid pagina-dados">
      <div className="offset-lg-3 col-lg-6">
        <form>
          <div className="row" >
            <div className="col-xl-8 col-lg-8 col-8 ">
              <label htmlFor="exampleInputEmail1" className="form-label">CPF</label>
              <input  onChange={(e) => setCPF(e.target.value)} maxLength={11} value={cpf} type="number" className="form-control" placeholder="Digite o CPF do cliente" aria-describedby="button-addon2" name="txtCPF" />
            </div>
            <div className="col-xl-2 col-lg-2 col-2 ">
              <button onClick={(e) => setPesquisa(cpf)} className="btn btn-outline-danger limpar" type="button" id="button-busca"><i className="fas fa-search"></i> Pesquisar</button>
            </div>
            <div className="col-xl-2 col-lg-2 col-2 ">
              <button onClick={(e) => Limpar()} className="btn btn-outline limpar" type="button" ><i className="fas fa-eraser"></i>Limpar</button>
            </div>            
          </div>
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-8">
              <label htmlFor="exampleInputEmail1" className="form-label">Parceiro</label>
              <input /*onChange={(e) => setNome(e.target.value)}*/ value={par_nome} type="text" className="form-control" id="exampleInputrazao" aria-describedby="emailHelp" disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-4">
              <label htmlFor="exampleInputEmail1" className="form-label">Cadastro</label>
              <input /*onChange={(e) => setNome(e.target.value)}*/ value={par_cadastro} type="text" className="form-control" id="exampleInputrazao" aria-describedby="emailHelp" disabled />
            </div>            
          
          </div>
          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">Pessoa</label>
            <input /*onChange={(e) => setNome(e.target.value)}*/ value={nomerazao} type="text" className="form-control" id="exampleInputrazao" aria-describedby="emailHelp" disabled />
          </div>
         
        </form>
      </div>
      <Footer className="footer navbar-fixed-bottom" />
    </div>    
                    {
                        erro != '' ?
                            <SweetAlert
                                danger
                                showCloseButton
                                confirmBtnText="OK"
                                confirmBtnBsStyle="danger"
                                onConfirm={() => setErro('')}
                                title="Falha"
                                reverseButtons={false}
                                openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                                closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                            >   {erro}
                            </SweetAlert> : null
                    }    


                  {
                        sucesso != '' & tipo==='C' ?
                            <SweetAlert
                                success
                                showCloseButton
                                confirmBtnText="Continuar"
                                confirmBtnBsStyle="success"
                                onConfirm={() => setSucesso('')}
                                title="Sucesso"
                                reverseButtons={false}
                                openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                                closeAnim={{ name: 'hideSweetAlert', duration: 100 }}>
                                Cliente <b>{par_nome}</b>, {nomerazao} cadastrado desde <b>{par_cadastro}</b>!
                            </SweetAlert> : null
                  }   

                  {
                        sucesso != '' & tipo==='P' ?
                            <SweetAlert
                                success
                                showCloseButton
                                confirmBtnText="Continuar"
                                confirmBtnBsStyle="success"
                                onConfirm={() => setSucesso('')}
                                title="Sucesso"
                                reverseButtons={false}
                                openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                                closeAnim={{ name: 'hideSweetAlert', duration: 100 }}>
                                Esse CPF é referente a parceria entre <b>FLORESTA e {par_nome}</b>!
                                <p></p>É só aproveitar e comprar!
                            </SweetAlert> : null
                  }                    

  </div>
}

export default ParceriaCPF;